import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Fab } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import AppSidebar, {
  APP_DRAWER_WIDTH_CLOSED,
  APP_DRAWER_WIDTH_OPEN,
} from './components/AppSidebar';
import HomePage from './pages/HomePage';
import PlayPage from './pages/PlayPage';
import StatsPage from './pages/StatsPage';
import AdminPage from './pages/AdminPage';
import SettingsPage from './pages/SettingsPage';
import { isAdminEnabled } from './config/adminAccess';

function App() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [desktopOpen, setDesktopOpen] = React.useState(false);

  const handleDrawerToggle = React.useCallback(() => {
    setMobileOpen((prevState) => !prevState);
  }, []);

  const handleCloseMobileDrawer = React.useCallback(() => {
    setMobileOpen(false);
  }, []);

  const handleDesktopDrawerToggle = React.useCallback(() => {
    setDesktopOpen((prevState) => !prevState);
  }, []);

  const activeDrawerWidth = desktopOpen ? APP_DRAWER_WIDTH_OPEN : APP_DRAWER_WIDTH_CLOSED;
  const adminEnabled = isAdminEnabled();

  return (
    <Box className="App" sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f5f7fb' }}>
      <Fab
        size="small"
        color="default"
        aria-label="Open navigation"
        onClick={handleDrawerToggle}
        sx={{
          display: { xs: 'inline-flex', sm: 'none' },
          position: 'fixed',
          top: 'calc(env(safe-area-inset-top, 0px) + 10px)',
          left: 10,
          zIndex: (theme) => theme.zIndex.drawer + 2,
          boxShadow: 4,
          backgroundColor: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(4px)',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,1)',
          },
        }}
      >
        <MenuIcon fontSize="small" />
      </Fab>

      <AppSidebar
        mobileOpen={mobileOpen}
        onCloseMobile={handleCloseMobileDrawer}
        desktopOpen={desktopOpen}
        onToggleDesktop={handleDesktopDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${activeDrawerWidth}px)` },
        }}
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/play" element={<PlayPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/admin" element={adminEnabled ? <AdminPage /> : <Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>
    </Box>
  );
}

export default App;
